'use client';

import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useRef } from 'react';

import { springBounce, staggerContainer } from './animations';

export const MaxBenefitSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const shouldReduceMotion = useReducedMotion();

  const content = (
    <div className="flex flex-col items-center gap-20 text-center">
      <div className="flex flex-col items-center gap-8">
        <p className="font-400 text-Gray-white typo-body2">
          기부 할수록 혜택은 더 늘어나요
        </p>
        <h2 className="font-700 typo-h5">
          <span className="text-Gray-white">웰로가 MAX로 드려요~</span>
          <br />
          <span className="text-[#e4302c]">최대 135만원 상당 혜택</span>
        </h2>
      </div>
      <div className="flex size-48 items-center justify-center rounded-pill bg-[#e4302c]">
        <svg
          width="17"
          height="22"
          viewBox="0 0 17 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.7579 13.8544L9.08077 21.7518C9.00509 21.8297 8.91415 21.8916 8.81435 21.9344C8.71454 21.9773 8.60694 22 8.49946 22C8.39198 22 8.28548 21.9773 8.18458 21.9344C8.08368 21.8916 7.99384 21.8297 7.91816 21.7518L0.241008 13.8544C-0.0803359 13.5238 -0.0803359 12.9879 0.241008 12.6573C0.562352 12.3268 1.08334 12.3268 1.40468 12.6573L7.67798 19.1106V0.846154C7.67798 0.379077 8.04649 0 8.50053 0C8.95458 0 9.32309 0.379077 9.32309 0.846154V19.1106L15.5964 12.6573C15.9177 12.3268 16.4387 12.3268 16.7601 12.6573C17.0814 12.9879 17.0793 13.5238 16.7579 13.8544Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );

  if (shouldReduceMotion) {
    return (
      <section className="flex w-full flex-col items-center bg-Gray-black px-24 pb-40">
        {content}
      </section>
    );
  }

  return (
    <section className="flex w-full flex-col items-center bg-Gray-black px-24 pb-40">
      <motion.div
        ref={ref}
        variants={staggerContainer}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        className="flex w-full flex-col items-center"
      >
        <motion.div variants={springBounce}>{content}</motion.div>
      </motion.div>
    </section>
  );
};
